// extracted by mini-css-extract-plugin
module.exports = {"error":"src-containers-form-SettingsUser-components-SocialNetworks-styles__error"};